import { PatientListParams } from '../../pages/Patient/Patient.types'

export const INITIAL_FILTER_PARAMS: PatientListParams = {
  page: 1,
  itemsPerPage: 10,
  term: '',
  ownership: '',
  situation: '',
  clinics: [],
  status: [],
}
